import { render } from "./ExhibitionsView.vue?vue&type=template&id=6a71a17e"
import script from "./ExhibitionsView.vue?vue&type=script&lang=js"
export * from "./ExhibitionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__